import React, { useEffect, useRef } from "react";

// confetti
const COLORS = [
    "#f44336", "#e91e63", "#9c27b0", "#3f51b5",
    "#2196f3", "#00bcd4", "#4caf50", "#ffeb3b",
    "#ff9800", "#ff5722",
];

const random = (min, max) => Math.random() * (max - min) + min;

class Particle {
    constructor(canvas) {
        this.canvas = canvas;
        this.reset();
    }

    reset() {
        this.x = random(0, this.canvas.width);
        this.y = random(-this.canvas.height, 0);
        this.w = random(6, 14);
        this.h = random(4, 10);
        this.color = COLORS[Math.floor(random(0, COLORS.length))];
        this.vx = random(-2, 2);
        this.vy = random(2, 6);
        this.angle = random(0, Math.PI * 2);
        this.spin = random(-0.15, 0.15);
        this.alpha = 1;
    }

    update() {
        this.x += this.vx;
        this.y += this.vy;
        this.angle += this.spin;
        this.vy += 0.05; // gravity
        if (this.y > this.canvas.height) this.reset();
    }

    draw(ctx) {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.angle);
        ctx.globalAlpha = this.alpha;
        ctx.fillStyle = this.color;
        ctx.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
        ctx.restore();
    }
}

const LeadWonConfetti = ({ active, onDone }) => {
    const canvasRef = useRef(null);
    const rafRef = useRef(null);
    const timerRef = useRef(null);

    useEffect(() => {
        if (!active) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const particles = Array.from({ length: 160 }, () => new Particle(canvas));

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            particles.forEach((p) => { p.update(); p.draw(ctx); });
            rafRef.current = requestAnimationFrame(animate);
        };

        animate();

        // Stop after 3.5 seconds
        timerRef.current = setTimeout(() => {
            cancelAnimationFrame(rafRef.current);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            if (onDone) onDone();
        }, 3500);

        return () => {
            cancelAnimationFrame(rafRef.current);
            clearTimeout(timerRef.current);
        };
    }, [active, onDone]);

    if (!active) return null;

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                pointerEvents: "none",
                zIndex: 9999,
            }}
        />
    );
};

export default LeadWonConfetti;